'use client';
import React, { useState, useEffect } from 'react';

const carouselImages = [
{
  url: "",
  caption: 'Serving the Bronzeville Community',
  sub: 'Chicago South Side'
},
{
  url: '',
  caption: 'Imam Abdullah Madyun',
  sub: 'Spiritual Leadership'
},
{
  url: "",
  caption: 'Offering Daily Salah and Jumu\'ah',
  sub: '321 E Pershing Rd'
},
{
  url: "",
  caption: 'Daily Lectures After Isha',
  sub: 'Knowledge & Community'
}];


export default function MasjidHero() {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % carouselImages?.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const prev = () => setCurrent((c) => (c - 1 + carouselImages?.length) % carouselImages?.length);
  const next = () => setCurrent((c) => (c + 1) % carouselImages?.length);

  return (
    <>
      <style>{`
        .mih-hero {
          position: relative;
          width: 100%;
          background: #060d1a;
          overflow: hidden;
        }
        .mih-hero-inner {
          position: relative;
          width: 100%;
          padding-top: 52%;
          max-height: 640px;
        }
        .mih-carousel-slide {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          transition: opacity 1s ease;
          opacity: 0;
        }
        .mih-carousel-slide.active { opacity: 1; }
        .mih-carousel-slide::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to bottom,
            rgba(6, 13, 26, 0.2) 0%,
            rgba(6, 13, 26, 0.1) 40%,
            rgba(6, 13, 26, 0.6) 80%,
            rgba(6, 13, 26, 0.9) 100%
          );
        }
        .mih-carousel-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10;
          background: rgba(8, 18, 38, 0.5);
          border: 1px solid rgba(59, 130, 246, 0.2);
          color: rgba(147, 197, 253, 0.8);
          width: 44px;
          height: 44px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          backdrop-filter: blur(8px);
        }
        .mih-carousel-nav:hover {
          background: rgba(37, 99, 235, 0.4);
          color: #fff;
          border-color: rgba(59, 130, 246, 0.5);
        }
        .mih-carousel-prev { left: 20px; }
        .mih-carousel-next { right: 20px; }
        .mih-carousel-caption {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 10;
          padding: 32px 40px;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
        }
        .mih-caption-text {}
        .mih-caption-main {
          font-family: 'Amiri', serif;
          font-size: clamp(20px, 3vw, 28px);
          font-weight: 700;
          color: #e2e8f0;
          display: block;
          margin-bottom: 4px;
          line-height: 1.2;
        }
        .mih-caption-sub {
          font-family: 'DM Sans', sans-serif;
          font-size: 12px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: rgba(147, 197, 253, 0.6);
          display: block;
        }
        .mih-carousel-dots {
          display: flex;
          gap: 6px;
          align-items: center;
        }
        .mih-carousel-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.25);
          border: none;
          cursor: pointer;
          padding: 0;
          transition: all 0.2s;
        }
        .mih-carousel-dot.active {
          background: #3b82f6;
          width: 20px;
          border-radius: 3px;
        }
        @media (max-width: 768px) {
          .mih-hero-inner { padding-top: 70%; }
          .mih-carousel-caption { padding: 20px; }
        }
      `}</style>
      <div className="mih-hero">
        <div className="mih-hero-inner">
          {carouselImages?.map((img, i) =>
          <div
            key={i}
            className={`mih-carousel-slide ${i === current ? 'active' : ''}`}
            style={{ backgroundImage: `url("${img?.url}")` }}
            role="img"
            aria-label={img?.caption} />

          )}
          <button className="mih-carousel-nav mih-carousel-prev" onClick={prev} aria-label="Previous slide">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <button className="mih-carousel-nav mih-carousel-next" onClick={next} aria-label="Next slide">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
          <div className="mih-carousel-caption">
            <div className={`mih-caption-text transition-all duration-700 ${loaded ? 'opacity-100' : 'opacity-0'}`}>
              <span className="mih-caption-main">{carouselImages?.[current]?.caption}</span>
              <span className="mih-caption-sub">{carouselImages?.[current]?.sub}</span>
            </div>
            <div className="mih-carousel-dots">
              {carouselImages?.map((_, i) =>
              <button
                key={i}
                className={`mih-carousel-dot ${i === current ? 'active' : ''}`}
                onClick={() => setCurrent(i)}
                aria-label={`Go to slide ${i + 1}`} />

              )}
            </div>
          </div>
        </div>
      </div>
    </>);

}